import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";

export const FiltrosReporte = ({
    fechaInicial,
    setFechaInicial,
    fechaFinal,
    setFechaFinal,
    onFiltrar,
}) => {
    return (
        <div className="formulario-fields-row align-items-end">
            <div className="formulario-field">
                <label htmlFor="fecha_inicial" className="m-0">
                    Fecha inicial
                </label>
                <DatePicker
                    selected={fechaInicial}
                    onChange={setFechaInicial}
                    showPopperArrow={false}
                    dateFormat="DD/MM/YYYY"
                    placeholderText="Fecha de inicio"
                    maxDate={fechaFinal || moment()}
                />
            </div>
            <div className="formulario-field">
                <label htmlFor="fecha_final" className="m-0">
                    Fecha final
                </label>
                <DatePicker
                    selected={fechaFinal}
                    onChange={setFechaFinal}
                    showPopperArrow={false}
                    dateFormat="DD/MM/YYYY"
                    placeholderText="Fecha final"
                    minDate={fechaInicial || undefined}
                />
            </div>
            <button
                className="btn btn-primary mt-auto"
                onClick={onFiltrar}
                disabled={!fechaInicial || !fechaFinal}
            >
                Filtrar
            </button>
        </div>
    );
};
